import React from 'react';
import {connect} from 'react-redux';
import {
	closeGroupTripsBannerPopup,
	updateEditGroupTripsBannerSection,
	openPagePicker,
	closePagePicker,
} from '../../actions';

import {
	deleteSingleImageFromTheSectionEditPopup,
	updateBodyFieldInTheSectionEditPopup,
	updateSingleCroppedImageInTheSectionEditPopup,
	updateSingleImageMetaInTheSectionEditPopup,
	updateImageInTheSectionEditPopup,
	updateSingleThumbCroppedImageInTheSectionEditPopup,
	updateTitleFieldInTheSectionEditPopup,
	updateGroupTripsBannerSectionSubheadingField,
	pickSectionPage
} from '../../sections/actions';

import {fetchImageRatios} from '../../../images/thunks';

import GroupTripsBannerSectionEditPopup from './group_trips_banner_section_edit';
import {clearPageSearchFilter} from '../../../page-picker/actions';
import {onSearchPages} from '../../../page-picker/thunks';
import {showErrMsgPopup} from '../../../../components/helpers/helpers';

class GroupTripsBannerSectionPopup extends React.Component {

	componentWillUpdate(nextProps) {
		if (nextProps.groupTripsBannerSectionEditOpen === true && this.props.groupTripsBannerSectionEditOpen === false) {
			this.props.fetchImageRatios();
		}
	}

	render() {

		return (
			<GroupTripsBannerSectionEditPopup
				open={this.props.groupTripsBannerSectionEditOpen}
				siteId={this.props.siteId}
				pageId={this.props.pageId}
				sectionId={this.props.groupTripsBannerSectionId}
				title={this.props.groupTripsBannerSectionTitle}
				body={this.props.groupTripsBannerSectionBody}
				subheading={this.props.groupTripsBannerSectionSubheading}
				page={this.props.groupTripsBannerSectionPage}
				image={this.props.groupTripsBannerSectionImage}
				onUpdateTitleField={
					title => this.props.updateGroupTripsBannerSectionTitleField(title)
				}
				onUpdateBodyField={
					body => this.props.updateGroupTripsBannerSectionBodyField(body)
				}
				onUpdateSubheadingField={
					body => this.props.updateGroupTripsBannerSectionSubheadingField(body)
				}
				sectionPagePickerPopupOpen={this.props.sectionPagePickerPopupOpen}
				pageSearchCriteria={this.props.pageSearchCriteria}
				allPagesBySearchCriteria={this.props.allPagesBySearchCriteria}
				onSearchPages={this.props.onSearchPages}
				onPickSectionPage={this.props.onPickSectionPage}
				openPagePicker={
					() => this.props.openPagePicker()
				}
				closePagePicker={
					() => {
						this.props.closePagePicker();
						this.props.clearPageSearchFilter();
					}
				}
				imageRatios={this.props.imageRatios.text}
				onUpdateImageField={
					(images) => this.props.updateImageSectionFields(images[0])
				}
				onDeleteImageField={
					() => this.props.deleteImageFromSectionField()
				}
				onCropImage={(image, imageUrlBlob, imageBlobObject) => {
					this.props.updateCroppedImage(image, imageUrlBlob, imageBlobObject);
				}}
				onCropThumbImage={(image, imageUrlBlob, imageBlobObject) => {
					this.props.updateThumbCroppedImage(image, imageUrlBlob, imageBlobObject);
				}}
				onImageMetaUpdate={(imageMeta) => {
					this.props.updateImageMeta(imageMeta);
				}}
				onHandleSubmit={() => {
					// Add crop alert on DONE for the group trips banner image
					let imageHasCrop = this.props.sectionData.image && this.props.sectionData.image.new && !this.props.sectionData.image.deleted && this.props.sectionData.image.croppedImage === null;
					imageHasCrop ? showErrMsgPopup("Cropping the Group Trips Banner Image is mandatory! Please click on it in order to CROP it.") : 
					this.props.updateGroupTripsBannerSectionContents(
						this.props.pageId,
						this.props.groupTripsBannerSectionId,
						this.props.sectionData,
					)
				}}
				onHandleClose={
					() => this.props.closeGroupTripsBannerSectionPopup()
				}
			/>
		)
	}


}

const mapStateToProps = (state, props) => ({
	sectionData: state.pageBuilderSectionPopup.data,
	groupTripsBannerSectionEditOpen: state.pageBuilder.groupTripsBannerSectionPopup.open,
	groupTripsBannerSectionId: state.pageBuilderSectionPopup.sectionId,
	groupTripsBannerSectionTitle: state.pageBuilderSectionPopup.data.title,
	groupTripsBannerSectionBody: state.pageBuilderSectionPopup.data.body,
	groupTripsBannerSectionSubheading: state.pageBuilderSectionPopup.data.subheading,
	groupTripsBannerSectionPage: state.pageBuilderSectionPopup.data.page,
	groupTripsBannerSectionImage: state.pageBuilderSectionPopup.data.image,
	imageRatios: state.images.ratios,

	sectionPagePickerPopupOpen: state.pageBuilder.sectionPagePickerPopup.open,
	clearPageSearchFilter: clearPageSearchFilter,
	pageSearchCriteria: state.pagePicker.pageSearchCriteria,
	allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,

	siteId: state.pageBuilder.pages[props.pageId].meta.site_id
});

export default connect(
	mapStateToProps, {
		closeGroupTripsBannerSectionPopup: closeGroupTripsBannerPopup,
		updateGroupTripsBannerSectionTitleField: updateTitleFieldInTheSectionEditPopup,
		updateGroupTripsBannerSectionBodyField: updateBodyFieldInTheSectionEditPopup,
		updateGroupTripsBannerSectionSubheadingField: updateGroupTripsBannerSectionSubheadingField,
		updateGroupTripsBannerSectionContents: updateEditGroupTripsBannerSection,
		fetchImageRatios,
		updateImageSectionFields: updateImageInTheSectionEditPopup,
		deleteImageFromSectionField: deleteSingleImageFromTheSectionEditPopup,
		updateCroppedImage: updateSingleCroppedImageInTheSectionEditPopup,
		updateThumbCroppedImage: updateSingleThumbCroppedImageInTheSectionEditPopup,
		updateImageMeta: updateSingleImageMetaInTheSectionEditPopup,

		openPagePicker: openPagePicker,
		closePagePicker: closePagePicker,
		onSearchPages: onSearchPages,
		onPickSectionPage: pickSectionPage,
	}
)(GroupTripsBannerSectionPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/group_trips_banner_popup.js